<template>
  <v-app class="grey lighten-4">
    <v-main class="content-panel">
      <!--  HEADER  -->
      <app-header :loggedUser="loggedUser" />
      <div >
      <v-alert style="left:25%;z-index:10;position:absolute"
      dismissible
      transition="fade-transition"
      :type="alertType"
      v-model="showAlert"
    >
    {{ message }}
    </v-alert>
    </div>
      <router-view  class="main-content mt-3 mb-12 ml-3" :style="viewStyles"></router-view>
      <app-footer />
    </v-main>
  </v-app>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
export default {
  name: "Header",
  components: {
    "app-header": Header,
    "app-footer": Footer,
  },
  data() {
    return {
      message: "nesto",
      alertType: "success",
      showAlert: false,
      loggedUser: {},
      windowHeight: window.innerHeight,
      /*loggedUser: {
        firstName: "Darko",
        lastName: "Dimitrijevic",
        email: "darko.dardi@gmail.com",
        address: {
          street: "Radise Bugarinovica",
          number: "19",
          city: "Sevojno",
          postalCode: "31205",
        },*/
        //username: /*localStorage.getItem("FD-username"),*/ "darkod",
        //role: /*localStorage.getItem("FD-role"),*/ "user",
      //},
    };
  },
  computed: {
    viewStyles () {
      return {
        height: `${this.windowHeight -150}px`,
        overflow: 'auto'
      }
    }
  },
  created() {
    this.setAuthType()
    this.setWelcomePage()
  },
  mounted() {
     if (localStorage.getItem('welcomePage') == 'true') {
        this.$router.replace({ name: "WelcomePage" });
      }
      else if(localStorage.getItem('authType') == 'AD') {
        this.login();
      }
      else if (!this.isLogged) {
        this.$router.replace({ name: "Login" });
     }
     this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
    })
    //this.setAuthType()
    //this.login()
  },
  methods: {
    displayNotificationMsg(msg, alerttype) {
        this.alertType = alerttype
        this.message = msg
        this.showAlert = true
        window.setTimeout(() => {
        this.showAlert = false
        }, 5000)    
        //this.showSnackbar = true;
        //this.snackbarText = msg;
    }, 
    /*isLoggedUser(){
      this.loggedUser = JSON.parse(localStorage.getItem('user'));
      return localStorage.getItem('logged');
    }*/
    isLogged(){
      return this.$store.getters.isLoggedIn;
    },
    login() {
      if(this.$config.AuthConfigType == 'AD' && !this.isLoggedIn) {
        this.$store.dispatch('login', {user: {}, authType: this.$config.AuthConfigType})
        .then(() => {
        })
        .catch(err => {
          this.message = err
          console.log(err)
        })
      }
    },
    setAuthType() {
      localStorage.setItem('authType', this.$config.AuthConfigType)
    },
    setWelcomePage() {
      localStorage.setItem('welcomePage', this.$config.ShowWelcomePage)
    },
    onResize() {
      this.windowHeight = window.innerHeight
    }
  }
};
</script>

<style lang="scss">
.content-panel {
  background-color: #f8f8f8;
}

html { overflow-y: hidden !important }
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
